module.exports = __webpack_public_path__ + "img/member-title.9d5c514f.jpg";